import { atom } from "recoil";

export const defaultAuthState = {
    isInitialized: false,
    userInfo: {},
    coUsrYn: null, // Y | N, coUsrYn
    type: null, // EXT | INT | OGA | LCM, lgnTp
    signedAt: null,
    isSignedIn: false,
};

const authState = atom<Record<string, any>>({
    key: "authState",
    default: defaultAuthState,
});

export default authState;
